import { render, staticRenderFns } from "./SecondaryNavItem.vue?vue&type=template&id=46744829&scoped=true&"
import script from "./SecondaryNavItem.vue?vue&type=script&lang=js&"
export * from "./SecondaryNavItem.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryNavItem.vue?vue&type=style&index=0&id=46744829&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46744829",
  null
  
)

export default component.exports